import { GetComponentProps } from 'topwrite';
import useConfig from '@@/use-config';
import Ad from '@/components/ad';

export default function After({}: GetComponentProps<'page:article:after'>) {

    const config = useConfig();

    const afterConfig = config.getValue('afterArticleBody');

    if (afterConfig && afterConfig.image) {
        return <Ad url={afterConfig.url} image={afterConfig.image} />;
    }

    return null;
}
